'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("IndexationsPersonnaliseesController", function ($scope, $http, $translate, $dialogBox, $notifications, customIndexationService, pageStatus, $authz) {
  var refreshIndexationList = function refreshIndexationList() {
    return customIndexationService.fetchIndexations().then(function (indexations) {
      $scope.indexations = indexations;
    });
  };
  $scope.isIntra = function () {
    return $authz.isIntra();
  };
  $scope.indexationTableConfig = {
    id: "indexationTable",
    source: "indexations",
    columns: [{
      attribute: 'name',
      title: $translate('marche.history.indexations.nom')
    }, {
      attribute: 'expression',
      title: $translate('marche.history.indexations.Indexation')
    }, {
      attribute: 'tauxDuJour',
      filter: 'taux',
      title: $translate('marche.history.indexations.TauxADate'),
      cellClass: 'align-c'
    }, {
      attribute: 'ownerName',
      title: $translate('marche.history.indexations.Createur'),
      cellClass: 'align-c',
      template: '<div>{{model.ownerName}}</div><div>{{model.metadata.creationDate|dateShort}}</div>'
    }, {
      attribute: "shared",
      title: $translate('marche.history.indexations.Partagee'),
      filter: "yesOrNo",
      cellClass: "align-c"
    }, {
      title: $translate('marche.history.indexations.Actions'),
      cellClass: "align-c",
      template: '' + '<div>' + '   <tl-icon-button ng-if="::model.userIsOwner" icon="edit" tl-tooltip="{{\'marche.history.indexations.Editer\'|translate}}" ng-click="editIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button icon="copy" tl-tooltip="{{\'marche.history.indexations.Dupliquer\'|translate}}" ng-click="copyIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button ng-if="::model.userIsOwner || isIntra()" icon="delete" ng-class="{\'show-delete-intra\':!model.userIsOwner && isIntra()}" tl-tooltip="{{\'marche.history.indexations.Supprimer\'|translate}}" ng-click="deleteIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button ng-if="model.userIsOwner && !model.shared" icon="share" tl-tooltip="{{\'marche.history.indexations.Partager\'|translate}}" ng-click="toggleShareIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button ng-if="model.userIsOwner && model.shared" icon="unshare" tl-tooltip="{{\'marche.history.indexations.AnnulerPartage\'|translate}}" ng-click="toggleShareIndexation(model.id)"></tl-icon-button>' + '</div>'
    }]
  };
  refreshIndexationList();
  $scope.createNewIndexation = function () {
    customIndexationService.openCreationPopin().then(function () {
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.editIndexation = function (indexationId) {
    customIndexationService.openEditionPopin(indexationId).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.IndexationSauvegardee'));
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.copyIndexation = function (indexationId) {
    customIndexationService.openEditionPopin(indexationId, true).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.IndexationDupliquee'));
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.deleteIndexation = function (indexationId) {
    return $dialogBox.confirm({
      title: $translate('marche.history.indexations.SuppressionIndexation.title'),
      text: $translate('marche.history.indexations.SuppressionIndexation.text')
    }).then(function () {
      return customIndexationService.deleteIndexation(indexationId);
    }).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.IndexationSupprimee'));
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.toggleShareIndexation = function (indexationId) {
    return customIndexationService.toggleShareIndexation(indexationId).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.ModificationEffectuee'));
      refreshIndexationList();
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/indexations/indexationsPersonnalisees/indexationsPersonnalisees.js
// module id = 2851
// module chunks = 13